import bcb_1 from '../img/portImages/HCJ/bcb_1.jpg';
import bl_1 from '../img/portImages/HCJ/bl_1.jpg';
import cm_1 from '../img/portImages/HCJ/cm_1.png';
import gp_1 from '../img/portImages/HCJ/gp_1.jpg';
import im_1 from '../img/portImages/HCJ/im_1.png';
import lp_1 from '../img/portImages/HCJ/lp_1.jpg';
import nc_1 from '../img/portImages/HCJ/nc_1.png';
import ppg_1 from '../img/portImages/HCJ/ppg_1.png';
import rp_1 from '../img/portImages/HCJ/rp_1.png';
import sp_1 from '../img/portImages/HCJ/sp_1.jpg';
import sv_1 from '../img/portImages/HCJ/sv_1.jpg';
import vr_1 from '../img/portImages/HCJ/vr_1.jpg';

import ph_1 from '../img/portImages/OS/ph_1.jpg';
import ps_1 from '../img/portImages/OS/ps_1.jpg';

import ln_1 from '../img/portImages/3D/ln_1.jpg';
import sk_1 from '../img/portImages/3D/sk_1.jpg';
import wr_1 from '../img/portImages/3D/wr_1.jpg';

import bs_1 from '../img/portImages/GU/bs_1.jpg';

import gd_1 from '../img/portImages/GD/gd_1.jpg';
import gd_2 from '../img/portImages/GD/gd_2.jpg';
import gd_3 from '../img/portImages/GD/gd_3.jpg';
import gd_4 from '../img/portImages/GD/gd_4.jpg';
import gd_5 from '../img/portImages/GD/gd_5.jpg';

const portfolios = [
  {
    id: 1,
    category: 'Full-Stack',
    categories: ['HTML', 'CSS', 'JS', 'ReactJS', 'Firebase'],
    image: im_1,
    image_link: 'https://www.pinterest.pt/pin/888264726480072331/',
    link1: 'https://imafeel.netlify.app/',
    link2: '',
    title: 'Imafeel',
    text: 'Created with HTML, CSS, JS, ReactJS. Firebase',
  },
  {
    id: 2,
    category: 'Front-End',
    categories: ['HTML', 'CSS', 'JS', 'ReactJS'],
    image: rp_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474888587',
    link1: 'https://pedro-react-projects.netlify.app/',
    link2: 'https://github.com/PedroGrou/pedro-react-projects',
    title: 'ReactJS Basic Projects',
    text: 'Created with only HTML, CSS, JS and ReactJS',
  },
  {
    id: 3,
    category: 'Front-End',
    categories: ['HTML', 'CSS', 'JS', 'Bootstrap'],
    image: ppg_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474860009/',
    link1: 'https://portofolio-pedrogrou.netlify.app/',
    link2: 'https://github.com/PedroGrou/portfolio-project-html',
    title: 'First Portofolio',
    text: 'Created with only HTML, CSS and JS',
  },
  {
    id: 4,
    category: 'Full-Stack',
    categories: ['HTML', 'CSS', 'JS', 'PHP', 'MySQL', 'Bootstrap', 'CodeIgniter4'],
    image: nc_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474864708/',
    link1: '',
    link2: 'https://github.com/PedroGrou/projetocodeigniter4-php',
    title: 'StuffPublicações',
    text: 'Created with only HTML, CSS, JS and CodeIgniter4 PHP framework',
  },
  {
    id: 5,
    category: 'Front-End',
    categories: ['HTML', 'CSS', 'JS', 'Bootstrap'],
    image: cm_1,
    image_link: '',
    link1: 'https://cristalmultimedia.com/',
    link2: '',
    title: 'Cristal Multimedia',
    text: 'Created with only HTML, CSS and JS',
  },
  {
    id: 6,
    category: 'OutSystems',
    categories: ['RAD', 'WebApps', 'DB'],
    image: ph_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474866604/',
    link1: '',
    link2: '',
    title: 'Pharma+Leaf',
    text: 'Pharmacy Online for delivery with OutSystems Platform',
  },
  {
    id: 7,
    category: 'Animation',
    categories: ['Cinema4D'],
    image: ln_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474867000',
    link1: '',
    link2: '',
    title: 'INOVTV Logo Animation',
    text: 'Created with Cinema 4D Platform',
  },
  {
    id: 8,
    category: 'Front-End',
    categories: ['HTML', 'CSS', 'JS', 'Bootstrap'],
    image: vr_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474867460',
    link1: 'https://virtual-reality-project.netlify.app',
    link2: 'https://github.com/PedroGrou/virtualreality-html',
    title: 'Virtual Reality',
    text: 'Created with only HTML, CSS and JS',
  },
  {
    id: 9,
    category: 'Game Development',
    categories: ['Unity', 'C#', 'Illustrator', 'Audition'],
    image: bs_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474867023',
    link1: '',
    link2: '',
    title: 'BeSafe',
    text: 'Game about Human Traffic Awareness, created using Unity Platform and C#',
  },
  {
    id: 10,
    category: 'Front-End',
    categories: ['HTML', 'CSS'],
    image: bl_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474866954/',
    link1: 'https://baixa-lisboa.netlify.app',
    link2: 'https://github.com/PedroGrou/baixaLisboa-html',
    title: 'A Baixa de Lisboa',
    text: 'Created with only HTML and CSS',
  },
  {
    id: 11,
    category: 'Front-End',
    categories: ['HTML', 'CSS'],
    image: bcb_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474859892/',
    link1: 'https://cb-bordados.netlify.app',
    link2: 'https://github.com/PedroGrou/bordadosCB-html',
    title: 'Bordados de Castelo Branco',
    text: 'Created with only HTML and CSS',
  },
  {
    id: 12,
    category: 'Graphic Design',
    categories: ['Illustrator', 'Photoshop'],
    image: gd_2,
    image_link: 'https://www.pinterest.pt/pin/888264726474866689/',
    link1: '',
    link2: '',
    title: 'Seminar Agroday',
    text: 'Created with Adobe Illustrator and Photoshop',
  },
  {
    id: 13,
    category: 'OutSystems',
    categories: ['RAD', 'WebApps', 'DB', 'Mobile'],
    image: ps_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474867115/',
    link1: '',
    link2: '',
    title: 'PopStorm',
    text: 'Students Grades Informations WebApp, created with OutSystems Platform',
  },
  {
    id: 14,
    category: 'Graphic Design',
    categories: ['Illustrator', 'Photoshop'],
    image: gd_3,
    image_link: 'https://www.pinterest.pt/pin/888264726474866674/',
    link1: '',
    link2: '',
    title: 'Icon Logos',
    text: 'Created with Adobe Illustrator and Photoshop',
  },
  {
    id: 15,
    category: 'Animation',
    categories: ['Cinema4D', 'Photoshop', 'Illustrator'],
    image: sk_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474867158',
    link1: '',
    link2: '',
    title: 'Skolion',
    text: '3D Animation of a Board Game Book, created with Cinema 4D Platform',
  },
  {
    id: 16,
    category: 'Front-End',
    categories: ['HTML', 'CSS', 'Bootstrap'],
    image: sp_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474867190',
    link1: 'https://sapone.netlify.app/',
    link2: 'https://github.com/PedroGrou/sapone-html',
    title: 'Sapone',
    text: 'Created with only HTML and CSS',
  },
  {
    id: 17,
    category: 'Graphic Design',
    categories: ['Illustrator', 'Photoshop'],
    image: gd_4,
    image_link: 'https://www.pinterest.pt/pin/888264726474866666/',
    link1: '',
    link2: '',
    title: 'Gameday',
    text: 'Created with Adobe Illustrator and Photoshop',
  },
  {
    id: 18,
    category: 'Animation',
    categories: ['Cinema4D', 'Photoshop'],
    image: wr_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474867425/',
    link1: '',
    link2: '',
    title: 'World Rotation',
    text: '3D Animation of the world rotating, created with Cinema 4D Platform',
  },
  {
    id: 19,
    category: 'Front-End',
    categories: ['HTML', 'CSS', 'Bootstrap'],
    image: sv_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474867545',
    link1: 'https://seja-vegan.netlify.app',
    link2: 'https://github.com/PedroGrou/sejavegan-html',
    title: 'Seja Vegan',
    text: 'Created with only HTML and CSS',
  },
  {
    id: 20,
    category: 'Graphic Design',
    categories: ['Illustrator', 'Photoshop'],
    image: gd_5,
    image_link: 'https://www.pinterest.pt/pin/888264726474866655/',
    link1: '',
    link2: '',
    title: 'Inov2agro',
    text: 'Created with Adobe Illustrator and Photoshop',
  },
  {
    id: 21,
    category: 'Front-End',
    categories: ['HTML', 'CSS'],
    image: gp_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474874854/',
    link1: 'https://thegameplay-project.netlify.app',
    link2: 'https://github.com/PedroGrou/TheGamePlay-html',
    title: 'The GamePlay',
    text: 'Created with only HTML and CSS',
  },
  {
    id: 22,
    category: 'Graphic Design',
    categories: ['Illustrator', 'Photoshop'],
    image: gd_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474866702/',
    link1: '',
    link2: '',
    title: 'Cheese Contest Certificate',
    text: 'Created with Adobe Illustrator and Photoshop',
  },
  {
    id: 23,
    category: 'Front-End',
    categories: ['HTML', 'CSS'],
    image: lp_1,
    image_link: 'https://www.pinterest.pt/pin/888264726474864747/',
    link1: 'https://lisboa-pombalina.netlify.app/',
    link2: 'https://github.com/PedroGrou/lisboapombalina-html',
    title: 'Lisboa Pombalina',
    text: 'Created with only HTML and CSS',
  },
];

export default portfolios;
